import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import PdFileView from '../../../compensationRecommendation/compensation/pd/PdFileView'
import PdApplication from './PdApplication'
import PdFileRegistration from './PdFileRegistration'
import PdReturn from './PdReturn'

const Pd = () => {
  const { path } = useRouteMatch()
  const [selectedSection, setSelectedSection] = useState('pd')

  const actionListModule = useSelector(
    getUserModuleActions('application-registration', 'compensation', 'pd')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'application-registration',
      'compensation',
      'pd',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="pd">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('pd')
                    }}
                    eventKey="pd"
                  >
                    PD Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('pd-return')
                    }}
                    eventKey="pd-return"
                  >
                    PD Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'pd' ? (
              <>
                {checkPermission('view', actionListModule) && <PdApplication />}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <PdReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <PdFileRegistration type="file" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <PdFileRegistration type="return" {...props} />}
      />
      <Route
        path={`${path}/view-similar/:id`}
        render={(props) => <PdFileView type="similar" {...props} />}
      />
    </Switch>
  )
}

export default Pd
